<template>
  <div class="home-page">
    <header-block></header-block>
    <discover-block></discover-block>
    <choose-block :games-images="gamesIcons"></choose-block>
    <hidden-gems-block></hidden-gems-block>
    <legends-block :games-images="gamesIcons"></legends-block>
    <our-mission-block></our-mission-block>
    <learn-block></learn-block>
    <story-block></story-block>
    <footer-block></footer-block>
  </div>
</template>

<script>
import HeaderBlock from './snippets/HeaderBlock.vue'
import DiscoverBlock from './snippets/DiscoverBlock.vue'
import ChooseBlock from "./snippets/ChooseBlock.vue";
import HiddenGemsBlock from "./snippets/HiddenGemsBlock.vue";
import LegendsBlock from "./snippets/LegendsBlock.vue";
import OurMissionBlock from "./snippets/OurMissionBlock.vue";
import LearnBlock from "./snippets/LearnBlock.vue";
import StoryBlock from "./snippets/StoryBlock.vue";
import FooterBlock from "./snippets/FooterBlock.vue";

export default {
  components: {
    FooterBlock,
    StoryBlock,
    LearnBlock,
    OurMissionBlock,
    LegendsBlock,
    ChooseBlock,
    'header-block': HeaderBlock,
    'discover-block': DiscoverBlock,
    'choose-block': ChooseBlock,
    'hidden-gems-block': HiddenGemsBlock,
  },
  data() {
    return {
      gamesImages: [],
      gamesIcons: [],
    }
  },
  async mounted() {
    await this.$request.get('/true-world/games-images', null, response => {
      this.gamesImages = response.images;
      this.gamesIcons = response.icons;
    }, error => {
      console.log(error)
    });

  }
}
</script>

<style lang="less">
.home-page {
  background: #010209;
  .container {
    width: 1180px;
    margin: 0 auto;
  }
  .mobile {
    display: none;
  }

  @media screen and (max-width: 1439px) {
    .container {
      width: 850px;
    }
  }
  @media screen and (max-width: 1023px) {
    .container {
      width: 670px;
    }
  }
  @media screen and (max-width: 767px) {
    .container {
      width: 100%;
      padding: 0 20px;
    }
  }
  @media screen and (max-width: 429px) {
    .container {
      width: 100%;
      padding: 0 15px;
    }
  }
}
</style>
